import React from 'react';
import {makeStyles} from '@material-ui/styles';
import {
    Box,
    CardHeader,
    CardContent,
    Divider,
    Grid,
    Card,
    Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default
    },
    title: {
        fontWeight: 'bold',
        marginTop: '8px',
    }
}));

const CorporateColor = () => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardHeader
                title="Corporate Color"
            />
            <Divider/>
            <CardContent>
                <Typography
                    className={classes.title}
                    gutterBottom
                    color="primary"
                    component="p"
                    variant="subtitle2"
                >Main Palette</Typography>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.main" color="primary.contrastText" p={2}>
                            primary.main<br />
                            #5A4AE8
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.light" color="primary.contrastText" p={2}>
                            primary.light<br />
                            #9890FC
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="primary.dark" color="primary.contrastText" p={2}>
                            primary.dark<br />
                            #443ABD
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="common.black" color="common.white" p={2}>
                            common.black<br />
                            #282632
                        </Box>
                    </Grid>
                </Grid>

                <Typography
                    className={classes.title}
                    gutterBottom
                    color="primary"
                    component="p"
                    variant="subtitle2"
                >Secondary Palette</Typography>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={4}>
                        <Box bgcolor="gray.main" color="gray.contrastText" p={2}>
                            gray.main<br />
                            #D5DEE3
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box bgcolor="success.main" color="success.contrastText" p={2}>
                            success.main<br />
                            #20CB78
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box bgcolor="info.main" color="info.contrastText" p={2}>
                            info.main<br />
                            #0C8EFF
                        </Box>
                    </Grid>
                </Grid>

                <Typography
                    className={classes.title}
                    gutterBottom
                    color="primary"
                    component="p"
                    variant="subtitle2"
                >Tertiary Palette</Typography>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="gray.light" color="gray.contrastText" p={2}>
                            gray.light<br />
                            #516683
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="gray.dark" color="gray.contrastText" p={2}>
                            gray.dark<br />
                            #0C78E8
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="info.light" color="info.contrastText" p={2}>
                            info.light<br />
                            #6BD3FF
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="info.dark" color="info.contrastText" p={2}>
                            info.dark<br />
                            #0C78E8
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="success.light" color="success.contrastText" p={2}>
                            success.light<br />
                            #8AF4AB
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="success.dark" color="success.contrastText" p={2}>
                            success.dark<br />
                            #00AA83
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="secondary.light" color="secondary.contrastText" p={2}>
                            secondary.light<br />
                            #C766FF
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="secondary.dark" color="secondary.contrastText" p={2}>
                            secondary.dark<br />
                            #B43DE0
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="warning.light" color="warning.contrastText" p={2}>
                            warning.light<br />
                            #FF3F51
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="warning.dark" color="warning.contrastText" p={2}>
                            warning.dark<br />
                            #922FCD
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="error.light" color="error.contrastText" p={2}>
                            error.light<br />
                            #FF3F51
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Box bgcolor="error.dark" color="error.contrastText" p={2}>
                            error.dark<br />
                            #CC3051
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default CorporateColor;
